import { Checkbox, DataSource, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutRenditionEmailProfiles extends Layout {
    checkbox5: Checkbox;
    checkbox6: Checkbox;
    checkbox7: Checkbox;
    checkbox8: Checkbox;
    panel4: Panel;
    panel5: Panel;
    panel6: Panel;
    panel7: Panel;
    sourceRenditionEmailProfiles: DataSource;
    textbox11: Textbox;
    textbox12: Textbox;
    textbox13: Textbox;
    textbox14: Textbox;
    textbox15: Textbox;
    textbox16: Textbox;
    textbox17: Textbox;
    textbox18: Textbox;
    textboxEmailProfile: Textbox;
}
